import React, { Component } from "react";
import { Modal, Button, Icon } from "antd";

import "../style.scss";

interface ErrorModalProps {
  resetError: () => any;
  errorData: {
    type: string;
    title: string;
    body: string;
    status: number;
    errorDetail: string;
  };
  error: any;
}

interface ErrorModalState {
  errorDetailVisibility: boolean;
}

class ErrorModal extends Component<ErrorModalProps, ErrorModalState> {
  constructor(props: ErrorModalProps) {
    super(props);
    this.state = {
      errorDetailVisibility: false,
    };
  }
  hideModal = () => {
    this.setState({ errorDetailVisibility: false });
    this.props.resetError();
  };
  relogin = () => {
    setTimeout(() => window.location.reload(), 5000);
  };
  toggleErrorDetail = () => {
    this.setState({ errorDetailVisibility: !this.state.errorDetailVisibility });
  };
  componentWillUnmount() {
    this.setState({ errorDetailVisibility: false });
  }
  render() {
    const data = this.props.errorData;
    return (
      <Modal
        zIndex={1000000}
        title={
          <span className={`modal-title ${data.type}`}>
            <Icon type='close' />
            {data.title}
          </span>
        }
        visible={this.props.error}
        onOk={this.hideModal}
        onCancel={this.hideModal}
        okText='Ok'
        className='error-modal'
        footer={[
          <Button key='back' type='primary' onClick={this.hideModal}>
            Ok
          </Button>,
        ]}
      >
        <p className='error-detail'>
          {data.body}
          {data.status === 401 && this.relogin()}
          {data.errorDetail !== "" && (
            <div>
              <Button
                onClick={this.toggleErrorDetail}
                size='small'
                type='link'
                icon={
                  this.state.errorDetailVisibility
                    ? "caret-down"
                    : "caret-right"
                }
                className='error-detail-button'
              >
                Details
              </Button>
              {this.state.errorDetailVisibility && (
                <div className='details'>
                  {data.errorDetail && data.errorDetail.toString()}
                </div>
              )}
            </div>
          )}
        </p>
      </Modal>
    );
  }
}

export default ErrorModal;
